/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Program } from 'types/Program';
import { Panel, PanelItem } from '../../partials/panel';

type ProgramRecruitmentProps = {
	readOnly?: boolean;
	programData: Program;
};

export const ProgramRecruitment = ({ readOnly = false, programData }: ProgramRecruitmentProps) => {
	const { t } = useTranslation();

	return (
		<Panel title={t('programPanel.dashboard.recruitment.title')}>
			<>
				<PanelItem title={t('programPanel.dashboard.recruitment.title')} />
				<PanelItem
					title={t('misc.mentees')}
					value={programData?.menteeRecruitment}
					type="boolean"
					transformValue="on/off"
				/>
				<PanelItem
					title={t('misc.mentors')}
					value={programData?.mentorRecruitment}
					type="boolean"
					transformValue="on/off"
				/>
			</>
			<>
				<PanelItem title="&nbsp;" className="flex flex-row gap-1">
					<div>Mentee</div>
					<div>Mentor</div>
				</PanelItem>
				<PanelItem
					title={t('programPanel.dashboard.recruitment.applicationCount')}
					className="flex flex-row gap-1"
				>
					<div className="bold text-lg">
						{programData?.applicationStats?.menteeApplicationCount || 0}
						{!readOnly && (
							<Link
								to={{
									pathname: `/program/${programData?.name}/application/list`,
									search: '?applicationRole=mentee',
								}}
								className="text-purplish-blue ml-2"
							>
								<i className="fa-solid fa-arrow-up-right-from-square" />
							</Link>
						)}
					</div>
					<div className="bold text-lg">
						{programData?.applicationStats?.mentorApplicationCount || 0}
						{!readOnly && (
							<Link
								to={{
									pathname: `/program/${programData?.name}/application/list`,
									search: '?applicationRole=mentor',
								}}
								className="text-purplish-blue ml-2"
							>
								<i className="fa-solid fa-arrow-up-right-from-square" />
							</Link>
						)}
					</div>
				</PanelItem>
				<PanelItem
					title={t('programPanel.dashboard.recruitment.withPendingApproved')}
					className="flex flex-row gap-1"
				>
					<div className="text-muted">
						{programData?.applicationStats?.menteeApplicationPendingCount || 0}
						{!readOnly && (
							<Link
								to={{
									pathname: `/program/${programData?.name}/application/list`,
									search: '?applicationRole=mentee&approved=not+accepted',
								}}
								className="text-purplish-blue ml-2"
							>
								<i className="fa-solid fa-arrow-up-right-from-square" />
							</Link>
						)}
					</div>
					<div className="text-muted">
						{programData?.applicationStats?.mentorApplicationPendingCount || 0}
						{!readOnly && (
							<Link
								to={{
									pathname: `/program/${programData?.name}/application/list`,
									search: '?applicationRole=mentor&approved=not+accepted',
								}}
								className="text-purplish-blue ml-2"
							>
								<i className="fa-solid fa-arrow-up-right-from-square" />
							</Link>
						)}
					</div>
				</PanelItem>
			</>
			<>
				<PanelItem
					title={t('programPanel.dashboard.recruitment.usersWithoutApplicationCount')}
					value={programData?.stats?.usersWithoutApplicationCount}
					transformValue={({ value }) => (
						<>
							{Number(value) > 0 ? <span className="text-danger">{Number(value)}</span> : 0}
							{!readOnly && (
								<Link
									to={{
										pathname: `/program/${programData?.name}/membership/list`,
										search: '?application=without-application',
									}}
									className="text-purplish-blue ml-2"
								>
									<i className="fa-solid fa-arrow-up-right-from-square" />
								</Link>
							)}
						</>
					)}
				/>
			</>
		</Panel>
	);
};
